import React from "react";
import { Link } from "react-router-dom";

//import components
import SidebarContent from "./SidebarContent";

//import images
import logoLightSvg from "../../assets/images/logo/papermap-logo-wordmark--light 1.svg";
import logoDark from "../../assets/images/logo/papermap-logo-wordmark--dark 1.svg";
import logo from "../../assets/images/logo/pappermap-logo-wordmark.png";

const Sidebar = (props: any) => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="40px" />
            </span>
            <span className="logo-lg">
              <img src={logoLightSvg} alt="" height="30px" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logo} alt="" height="40px" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="30px" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
